// eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import {
    sortingBtnClass,
    deliveryType,
    commentType,
    paymentType,
    paymentStatus,
    orderDeliveryPeriod,
    orderColorCode,
    orderHandoverDeliveryDateColorCode,
    orderDeliveryTypeColorCode,
    orderDateCreatedColorCode,
    orderPaymentTypeColorCode,
    orderStatusColorCode,
    orderStatus,
    filterSimpleObjectArray,
    orderKeyMapper,
    orderKeys,
    truncate,
    dateTomorrow,
    dateSubtract,
    dateAdd,
    dateNow,
    date,
    dayToInt,
    isDay,
    daysToIntArray,
    isDateInDays,
    dateTimeStartOfDay,
    dateTimeEndOfDay,
    dateStartOfWeek,
    dateEndOfWeek,
    getLastDay,
    strUpperLower,
    getMappedItems,
    notificationCaption,
    notificationDescription,
} from 'src/js/mapper.js';

import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
    app.config.globalProperties.$mapper = {
            sortingBtnClass,
            deliveryType,
            commentType,
            paymentType,
            paymentStatus,
            orderDeliveryPeriod,
            orderColorCode,
            orderHandoverDeliveryDateColorCode,
            orderDeliveryTypeColorCode,
            orderDateCreatedColorCode,
            orderPaymentTypeColorCode,
            orderStatusColorCode,
            orderStatus,
            filterSimpleObjectArray,
            orderKeyMapper,
            orderKeys,
            truncate,
            dateTomorrow,
            dateSubtract,
            dateAdd,
            dateNow,
            date,
            dayToInt,
            isDay,
            daysToIntArray,
            isDateInDays,
            dateTimeStartOfDay,
            dateTimeEndOfDay,
            dateStartOfWeek,
            dateEndOfWeek,
            getLastDay,
            strUpperLower,
            getMappedItems,
            notificationCaption,
            notificationDescription,
    }
});
